import * as Yup from 'yup'

import { TEXTFIELD_REQUIRED_LENGTH } from '~/common/constants'

export const ResetPasswordSchema = (t) =>
  Yup.object().shape({
    password: Yup.string()
      .required(t('form.required'))
      .max(
        TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        t('form.maxLength', {
          max: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }),
      ),
    confirmPassword: Yup.string()
      .required(t('form.required'))
      .oneOf(
        [Yup.ref('password')],
        t('forgotPassword.resetPassword.validConfirmPassword'),
      )
      .max(
        TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        t('form.maxLength', {
          max: TEXTFIELD_REQUIRED_LENGTH.COMMON.MAX,
        }),
      ),
  })
